import { FloorplanGroupsService } from '@floorplans/services/floorplan-groups.service';
import { FloorplansService } from '@floorplans/services/floorplans.service';
import { FLOORPLAN_GROUPS_STORE } from '@floorplans/stores/floorplan-groups.store';
import { FLOORPLANS_STORE } from '@floorplans/stores/floorplans.store';

export const FLOORPLANS_PROVIDERS = [
  FloorplansService,
  FloorplanGroupsService,

  FLOORPLANS_STORE,
  FLOORPLAN_GROUPS_STORE
];
